export default __webpack_public_path__ + "static/media/movie-buddy.9c57d6fa.jpg";